// extracted by mini-css-extract-plugin
var _1 = "cognito-login-form-module--alert--620ba";
var _2 = "cognito-login-form-module--btn--78d41";
var _3 = "cognito-login-form-module--btnFilledFull--79ab2";
var _4 = "cognito-login-form-module--btnFull--b1ca5";
var _5 = "cognito-login-form-module--btnGap--b7ce0";
var _6 = "cognito-login-form-module--btnLabelStrong--4479c";
var _7 = "cognito-login-form-module--btnOutlined--5d578";
var _8 = "cognito-login-form-module--btnText--36950";
var _9 = "cognito-login-form-module--center--ffa8b";
var _a = "cognito-login-form-module--centerRow--8d46d";
var _b = "cognito-login-form-module--emailForm--79a8b";
var _c = "cognito-login-form-module--logo--bdbf1";
var _d = "cognito-login-form-module--muted--3711a";
var _e = "cognito-login-form-module--orDivider--51dc5";
var _f = "cognito-login-form-module--panel--21bc7";
var _10 = "cognito-login-form-module--root--74b7d";
var _11 = "cognito-login-form-module--social--e1207";
export { _1 as "alert", _2 as "btn", _3 as "btnFilledFull", _4 as "btnFull", _5 as "btnGap", _6 as "btnLabelStrong", _7 as "btnOutlined", _8 as "btnText", _9 as "center", _a as "centerRow", _b as "emailForm", _c as "logo", _d as "muted", _e as "orDivider", _f as "panel", _10 as "root", _11 as "social" }
